'use client';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';

interface IUseTabsIn {
  context: string;
  routes: string[];
}

interface IUseTabsOut {
  activeTabIndex: number;
  tabs: {
    href: string;
    label: string;
  }[];
}

const useTabs = ({ context, routes }: IUseTabsIn): IUseTabsOut => {
  const t = useTranslations();
  const pathname = usePathname();

  const parsedContext = context.replaceAll('_', '-');
  const tabs = routes.map((item) => ({
    href: `/${parsedContext}/${item.replaceAll('_', '-')}`,
    label: t(`${context}.tabs.${item}` as any)
  }));

  const regex = new RegExp('^/([a-z]{2})/' + parsedContext + '/', 'g');
  const modifiedRoute = pathname
    .replace(regex, `/${parsedContext}/`)
    .match(/^\/[^/]+\/[^/]+/)
    ?.at(0);

  const activeTabIndex = tabs.findIndex((item) => item.href === modifiedRoute);

  return {
    activeTabIndex,
    tabs
  };
};

export default useTabs;
